import {
  getAvailableBrowserLocale,
  getPrimaryBrowserLanguage,
  UZBEK_CYRILLIC_LOCALE,
  UZBEK_LATIN_LOCALE,
} from './normalize'

export function getRegionalLocale(context, { localesByRegion = {}, browserFallbackLocales = {} } = {}) {
  const { region, configuredLocales = [], availableLocales, languages, language } = context

  if (configuredLocales.includes(UZBEK_CYRILLIC_LOCALE) && region === 'UZ') {
    return getPrimaryBrowserLanguage(languages, language) === 'ru' ? UZBEK_CYRILLIC_LOCALE : UZBEK_LATIN_LOCALE
  }

  const geoFallbackLocale = browserFallbackLocales[region]
  if (geoFallbackLocale) {
    return getAvailableBrowserLocale(languages, language, availableLocales) || geoFallbackLocale
  }

  const specialRegionLang = localesByRegion[region]
  return specialRegionLang && availableLocales.includes(specialRegionLang) ? specialRegionLang : null
}
